/**
 * Representation of Registered Event which allows get result of the dispatch action
 */
class RegisteredGlobalEvent {
    constructor(successName, failureName, eventObject = window.document) {
        this.successName = successName;
        this.failureName = failureName;
        this.eventObject = eventObject;
    }
    /**
     * Subscribe to result success/fail
     */
    subscribe(resolve, reject) {
        const successCallback = ($event) => {
            resolve($event.detail);
            this.eventObject.removeEventListener(this.successName, successCallback);
            this.eventObject.removeEventListener(this.failureName, errorCallback);
        };
        const errorCallback = ($event) => {
            reject($event.detail);
            this.eventObject.removeEventListener(this.failureName, errorCallback);
            this.eventObject.removeEventListener(this.successName, successCallback);
        };
        this.eventObject.addEventListener(this.successName, successCallback);
        this.eventObject.addEventListener(this.failureName, errorCallback);
    }
}
export default RegisteredGlobalEvent;
//# sourceMappingURL=RegisteredGlobalEvent.js.map